const CHECK_EVERY_MS = 5000;
const CHECK_TIMEOUT_MS = 5000;

let down = false;
let timer = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(down));

export const isServerDown = () => down;

// listener(down) runs on every change; returns the unsubscribe function
export const subscribeServer = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const markServerUp = () => {
  clearTimeout(timer);
  timer = null;
  if (!down) return;
  down = false;
  notify();
};

const planCheck = () => {
  clearTimeout(timer);
  timer = setTimeout(checkServer, CHECK_EVERY_MS);
};

// any answer from the server (even an error page) means it can be reached
export const checkServer = async () => {
  if (!down) return;
  // a hidden tab asks nothing; it checks again when it is shown
  if (document.visibilityState === "hidden" || !navigator.onLine) {
    planCheck();
    return;
  }
  const controller = new AbortController();
  const stop = setTimeout(() => controller.abort(), CHECK_TIMEOUT_MS);
  try {
    await fetch(process.env.REACT_APP_BASE_API_URL, {
      mode: "no-cors",
      cache: "no-store",
      signal: controller.signal,
    });
    markServerUp();
  } catch (error) {
    planCheck();
  } finally {
    clearTimeout(stop);
  }
};

export const markServerDown = () => {
  if (down) return;
  down = true;
  notify();
  planCheck();
};

if (typeof window !== "undefined") {
  window.addEventListener("online", checkServer);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkServer();
  });
}

// no answer at all (not an error from the server, not a cancelled request)
export const isNoAnswer = (error) =>
  !!error &&
  !error.response &&
  !error.__CANCEL__ &&
  error.name !== "CanceledError";
